const USER_ID_KEYS = ['id', 'userId', 'user_id'];

function normalizeId(value: unknown): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const normalized = Number(value);
  return Number.isFinite(normalized) ? normalized : null;
}

function isDeletedFlag(value: unknown): boolean {
  return Number(value) === 1;
}

function getRecordUserId(record: Record<string, unknown>): number | null {
  for (const key of USER_ID_KEYS) {
    const normalized = normalizeId(record[key]);
    if (normalized !== null) {
      return normalized;
    }
  }

  return null;
}

function walkRecords(value: unknown, currentUserId: number | null, predicate: (record: Record<string, unknown>, currentUserId: number) => boolean, visited: Set<object>): boolean {
  if (currentUserId === null || value === null || value === undefined) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.some((item) => walkRecords(item, currentUserId, predicate, visited));
  }

  if (typeof value !== 'object') {
    return false;
  }

  const record = value as Record<string, unknown>;
  if (visited.has(record)) {
    return false;
  }

  visited.add(record);

  if (predicate(record, currentUserId)) {
    return true;
  }

  return Object.values(record).some((item) => walkRecords(item, currentUserId, predicate, visited));
}

export function containsCurrentUserRecord(value: unknown, currentUserId: number | string | null | undefined): boolean {
  const normalizedCurrentUserId = normalizeId(currentUserId);
  return walkRecords(value, normalizedCurrentUserId, (record, userId) => getRecordUserId(record) === userId, new Set<object>());
}

export function containsDeletedCurrentUserRecord(value: unknown, currentUserId: number | string | null | undefined): boolean {
  const normalizedCurrentUserId = normalizeId(currentUserId);
  return walkRecords(value, normalizedCurrentUserId, (record, userId) => getRecordUserId(record) === userId && isDeletedFlag(record.deleted_user), new Set<object>());
}
